module.exports = __webpack_public_path__ + "img/marketplace_5.7badb555.png";